import { render, staticRenderFns } from "./ChangePhotoBookTypeDialog.vue?vue&type=template&id=34916fc7&"
import script from "./ChangePhotoBookTypeDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePhotoBookTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports